import { Box, NumberInput, Text } from '@ksyos/design-system';
import type { ServiceType } from '@common/enums';
import { FormatCurrency } from '@frontend/components/elements/FormatCurrency';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';
import type { OrganizationContractSettingsFormState } from './OrganizationContractSettings';

interface OrganizationContractSettingsContractPriceProps {
    index: number;
    isEditing: boolean;
    serviceType: ServiceType;
}

export function OrganizationContractSettingsContractPrice(
    props: Readonly<OrganizationContractSettingsContractPriceProps>
) {
    const form = useFormContext<OrganizationContractSettingsFormState>();
    const contractPrice = form.values[props.serviceType][props.index].contractPrice;

    if (props.isEditing) {
        return (
            <NumberInput
                aria-label="prijsafspraak"
                error={form.errors.getMessage(`${props.serviceType}.${props.index}.contractPrice`)}
                isCurrency={true}
                maximumFractionDigits={4}
                name={`${props.serviceType}.${props.index}.contractPrice`}
                onChange={(value) => {
                    form.handleChange({
                        name: `${props.serviceType}.${props.index}.contractPrice`,
                        value,
                    });
                }}
                value={contractPrice}
            />
        );
    }

    return (
        <Box minHeight="40px">
            <Text pt={2}>
                {contractPrice ? (
                    <FormatCurrency
                        maximumFractionDigits={4}
                        value={contractPrice}
                        valueIsDecimal={true}
                    />
                ) : (
                    '-'
                )}
            </Text>
        </Box>
    );
}
